
        const symbolId = 'fire';
        const symbolUrl = '/build/app/img/symbols.d97f4346.svg#' + symbolId;

        export default {
            id: symbolId,
            url: symbolUrl,
            viewBox: undefined,
            toString: function() {
                return this.url;
            }
        };

        export const url = symbolUrl;
        export const id = symbolId;
    